import { serviceOperationApi } from "./api";

// Tablas que usan el endpoint genérico /Data con country_id
const DATA_TABLES = [
  "condicion",
  "origen_devolucion",
  "sintoma",
  "aceptamos_devolucion",
  "taller_deposito_destino",
  "taller_componente",
  "taller_descripcion",
  "taller_estado_sku",
  "taller_estetica_packaging",
  "taller_estetica_producto",
  "taller_falla",
  "taller_lote",
  "taller_motivo_del_scrap",
  "taller_reparacion",
  "taller_responsable",
];

// Filtra inactivos y elimina duplicados por id (el API puede retornar ids repetidos)
const toUniqueActive = (items) => {
  const seen = new Set();
  return items.filter((item) => {
    if (!item.active || seen.has(item.id)) return false;
    seen.add(item.id);
    return true;
  });
};

/**
 * Obtiene todas las listas desplegables del formulario en paralelo.
 * Reemplaza 15+ llamadas secuenciales por una sola ronda de requests.
 */
export async function fetchFormLookups({ accessToken, countryId }) {
  const headers = { Authorization: `Bearer ${accessToken}` };

  // deposito_destino usa un endpoint distinto (/WarehouseData), el resto usa /Data
  const [warehouseRes, ...tableResponses] = await Promise.all([
    serviceOperationApi.get("/WarehouseData", {
      params: { country_id: countryId },
      headers,
    }),
    ...DATA_TABLES.map((table) =>
      serviceOperationApi.get("/Data", {
        params: { table, country_id: countryId },
        headers,
      })
    ),
  ]);

  return {
    deposito_destino: toUniqueActive(warehouseRes.data),
    ...Object.fromEntries(
      DATA_TABLES.map((table, idx) => [
        table,
        toUniqueActive(tableResponses[idx].data),
      ])
    ),
  };
}
